import React from 'react';
import PropTypes from 'prop-types';
import map from 'lodash/map';
import add from 'lodash/add';
import { FormattedMessage, FormattedNumber } from 'react-intl';

import Table from '../../../../../../elements-table/table';

export const AddonsTable = ({
  total,
  taxTotal,
  totalWithTax,
  items = [],
  currency,
  title,
  headers
}) => {
  return (
    <div>
      <h4>{title}</h4>
      <Table
        tableHeaders={headers}
        tableBody={
          <div>
            {map(items, (item = {}) => {
              const {
                item_id: itemId = '',
                us_sales_tax_rate: usSalesTaxRate = 0,
                us_sales_tax_amount: usSalesTaxAmount = 0,
                primary_amount: primaryAmount = 0,
                description = ''
              } = item;

              const amountWithTax = add(usSalesTaxAmount, primaryAmount);

              return <div className="flex space-between table-row" key={itemId}>
                <div className="flex-basis-20">
                  {description}
                </div>
                <div className="flex-basis-20">
                  <FormattedNumber value={primaryAmount} currency={currency} style="currency" />
                </div>
                <div className="flex-basis-10">
                  {0 < usSalesTaxRate && <FormattedNumber value={usSalesTaxRate} currency={currency} style="percent" />}
                </div>
                <div className="flex-basis-20">
                  <FormattedNumber value={usSalesTaxAmount} currency={currency} style="currency" />
                </div>
                <div className="flex-basis-15">
                  <FormattedNumber value={amountWithTax} currency={currency} style="currency" />
                </div>
              </div>;
            })}
            <hr className="margin-md-bottom margin-md-top" />
            <div className="flex space-between table-row">
              <div className="flex-basis-20 heavy">
                <FormattedMessage id="hosting.sales_tax_addons_table.totals" defaultMessage="Totals" />
              </div>
              <div className="flex-basis-20 heavy">
                <FormattedNumber value={total} currency={currency} style="currency" />
              </div>
              <div className="flex-basis-10"/>
              <div className="flex-basis-20 heavy">
                <FormattedNumber value={taxTotal} currency={currency} style="currency" />
              </div>
              <div className="flex-basis-15 heavy">
                <FormattedNumber value={totalWithTax} currency={currency} style="currency" />
              </div>
            </div>
          </div>
        }
      />
    </div>
  );
};

AddonsTable.propTypes = {
  total: PropTypes.number,
  taxTotal: PropTypes.number,
  totalWithTax: PropTypes.number,
  items: PropTypes.array,
  currency: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  headers: PropTypes.array
};
